"use client";

import * as HeroiconsSolid from '@heroicons/react/24/solid';
import * as HeroiconsOutline from '@heroicons/react/24/outline';

interface IconProps {
  name: string;
  size?: number;
  className?: string;
  variant?: 'solid' | 'outline';
}

const Icon: React.FC<IconProps> = ({ 
  name, 
  size = 24, 
  className = '', 
  variant = 'outline' 
}) => {
  const icons = variant === 'solid' ? HeroiconsSolid : HeroiconsOutline;
  const IconComponent = (icons as any)[name];

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in Heroicons ${variant}`);
    return null;
  }

  return (
    <IconComponent data-component-id="src/components/ui/Icon.tsx:28:4" data-component-path="src/components/ui/Icon.tsx" data-component-line="28" data-component-end-line="32" data-component-file="Icon.tsx" data-component-name="IconComponent" data-component-content="%7B%22elementName%22%3A%22IconComponent%22%2C%22className%22%3A%22%5Bvar%3AclassName%5D%22%7D" 
      width={size} 
      height={size} 
      className={className}
    />
  );
};

export default Icon;